import React, { useEffect } from 'react';
import AOS from 'aos';

const HeroSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  const heroStyle = {
    background: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/images/image00007.jpeg")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  };

  return (
    <section 
      id="hero" 
      className="min-h-screen flex items-center justify-center text-white"
      style={heroStyle}
    >
      <div className="max-w-4xl mx-auto text-center px-6" data-aos="fade-up">
        <h1 className="text-5xl font-light tracking-wide mb-8">KHOSIKHADI MMATLALA WA MUDAU</h1>
        <p className="text-xl mb-4 opacity-90 font-light">Ndi Mudau wa Tshakuma dombwe Madzivhandila Ndi Muduhulu wa Mangedzani</p>
        <p className="text-lg tracking-widest">STORYTELLER • HEALER • ARTIST</p>
        <div className="scroll-prompt mt-20">
          <p className="text-sm tracking-widest mb-4">SCROLL TO EXPLORE</p>
          <i className="fas fa-chevron-down"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;